import { GenericForm } from '@neo/blocks/forms/generic-form'
import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import { identity, pickBy } from 'lodash'
import { TableContainer } from 'v2/shared/components/table-container'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import { ConvChannels } from 'v2/types/api/conversations'
import { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'
import { generateToastsForMutation } from 'v2/utils/toasts'
import { useChannelConfigurationMutation, useChannelConfigurationQuery } from '../queries'
import { callChannelDefaultValues, getCallChannelFields } from './channel.config'

export const CallChannel = () => {
  const { data: formData } = useChannelConfigurationQuery(ConvChannels.CALL)

  const { mutate, isPending } = useChannelConfigurationMutation(ConvChannels.CALL)
  const { hasPermission } = usePermissions()

  return (
    <TableContainer>
      <GenericForm<typeof callChannelDefaultValues>
        defaultValues={{
          ...callChannelDefaultValues,
          ...formData,
          channel_settings: formData?.channel_settings ?? callChannelDefaultValues.channel_settings,
        }}
        id="call-channel-settings"
        isSubmitting={isPending}
        submitText={isPending ? 'Saving...' : 'Save'}
        includeSubmitButton={hasPermission(RbacModules.channelCalls, RbacPermissionTypes.create)}
        className="gap-4"
        fields={getCallChannelFields() as GenericFieldConfig<typeof callChannelDefaultValues>}
        onSubmit={(values) =>
          mutate(
            pickBy(values, identity) as typeof callChannelDefaultValues,
            generateToastsForMutation(
              { title: 'Success', description: 'Call settings updated successfully' },
              { title: 'Error', description: 'Failed to update call settings' },
            ),
          )
        }
      />
    </TableContainer>
  )
}
